import React from 'react'
import styled from 'styled-components'
import AlertTriangleIcon from '../../../assets/icons/icon-alert-triangle.svg'

const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  pointer-events: none;
`

const ModalContainer = styled.div`
  padding: 32px;
  background: white;
  box-shadow: 0px 5px 10px rgba(0, 35, 75, 0.15);
  border-radius: 8px;
  border: 1px solid #CE0000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 417px;
  pointer-events: auto;
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 21px;
`

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const WarningIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`

const ModalTitle = styled.h3`
  color: #00234B;
  font-size: 18px;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  line-height: 28px;
  margin: 0;
`

const ModalBody = styled.p`
  color: #00234B;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`

const ModalLink = styled.a`
  color: #0082CE;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  text-decoration: underline;
  line-height: 24px;
  
  &:hover {
    opacity: 0.8;
  }
`

const SuspensionModal = () => {
  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalContent>
          <ModalHeader>
            <WarningIcon src={AlertTriangleIcon} alt="Warning" />
            <ModalTitle>Failure to Meet Acceptable Progress</ModalTitle>
          </ModalHeader>
          <ModalBody>
            You are currently suspended for not meeting acceptable progress requirements. Please review the{' '}
            <ModalLink 
              href="https://resources.pga.org/my-membership/associate-program/pga-associate-acceptable-progress-tracking"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acceptable Progress policy
            </ModalLink>
            {' '}for more information. If you need further assistance, contact{' '}
            <ModalLink 
              href="mailto:membership@pga.org"
            >
              Membership Services
            </ModalLink>.
          </ModalBody>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  )
}

export default SuspensionModal

